import React from 'react';
import { photos } from '../../data/site';
import { ButtonLink } from '../ui/ButtonLink';
import { Container } from '../ui/Container';
import { Reveal } from '../ui/Reveal';
import { SectionTitle } from '../ui/SectionTitle';
const approach = [{
  title: 'Builds on strengths',
  body: 'Coaching starts from what each student already does well.'
}, {
  title: 'Your own pace',
  body: 'Students progress when they’re ready, not on someone else’s timeline.'
}, {
  title: 'Hard work and persistence',
  body: 'Effort is noticed, and trying again is part of the lesson.'
}];
export function Coach() {
  return <section id="coach" aria-labelledby="coach-title" className="on-dark bg-ink py-20 text-white lg:py-28" data-id="element-52" data-mp="1xna2emjzp93y">
      <Container className="grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-53" data-mp="1soyskbtp2ylq">
        <figure className="mx-auto w-full max-w-[340px] lg:col-span-4 lg:mx-0 lg:max-w-none" data-id="element-54" data-mp="26mx3t8cpyex0">
          <img src={photos.coachPortrait} alt="Master Chee Bates, owner and head coach of Bates Taekwondo" className="aspect-[4/5] w-full rounded object-cover lg:max-w-[360px]" style={{
          objectPosition: '50% 0%'
        }} loading="lazy" data-id="element-55" data-mp="22mwcin4iu98j" />
          <figcaption className="mt-4 text-sm text-white/65" data-id="element-56" data-mp="3gngfnw3oazk7">Master Chee Bates, owner and head coach</figcaption>
        </figure>

        <div className="lg:col-span-8" data-id="element-57" data-mp="3lodxg7krtrl6">
          <Reveal data-id="element-58" data-mp="3qlvv31tc8kdv">
            <SectionTitle id="coach-title" data-id="element-59" data-mp="3qmfg4reabow4">Meet Coach Chee</SectionTitle>
            <p className="text-pretty mt-6 max-w-[40rem] text-lg leading-relaxed text-white/85 sm:text-xl" data-id="element-60" data-mp="3unhgxcnuo907">
              Master Chee Bates has coached Taekwondo for more than 25 years. His approach is simple to describe and
              demanding to do well: find each student’s strengths, build on them, and teach the value of hard work and
              persistence.
            </p>
            <p className="text-pretty mt-4 max-w-[40rem] leading-relaxed text-white/70" data-id="element-61" data-mp="d4wo6vstjxqg">
              A nervous five-year-old and a teen chasing a competitive goal both get attention that fits them. Students
              learn at their own pace, with feedback that meets them where they are.
            </p>
          </Reveal>

          <ul className="mt-10 grid gap-6 border-t border-white/15 pt-8 sm:grid-cols-3" data-id="element-62" data-mp="27i0h6c9vgfs">
            {approach.map(item => <li key={item.title} data-id="element-63" data-mp="3tle6s26z6svp">
                <h3 className="font-display text-[1.4rem] font-semibold uppercase leading-tight tracking-wide" data-id="element-64" data-mp="3tkcmd742ku1b">{item.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-white/70" data-id="element-65" data-mp="69lkwkgx5vd7">{item.body}</p>
              </li>)}
          </ul>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-66" data-mp="l5b3s9qt5sdp">
            <ButtonLink href="/instructors" data-id="element-67" data-mp="g8kmjj39oqqp">Meet all our instructors</ButtonLink>
            <a href="/about-us" className="inline-flex min-h-[44px] items-center text-sm font-semibold text-white/80 underline underline-offset-4 hover:text-white" data-id="element-68" data-mp="2mxh1evuwgp8w">Our coaching philosophy</a>
          </div>
        </div>
      </Container>
    </section>;
}